import { LEVELS, type GameDef, type Level } from "./types";
import { GAMES as BEGINNER_1 } from "./beginner/part1";
import { GAMES as BEGINNER_2 } from "./beginner/part2";
import { GAMES as INTERMEDIATE_1 } from "./intermediate/part1";
import { GAMES as INTERMEDIATE_2 } from "./intermediate/part2";
import { GAMES as EXPERT_1 } from "./expert/part1";
import { GAMES as EXPERT_2 } from "./expert/part2";

/** Each level's pool: 20 games, 10 drawn per session. */
export const POOLS: Record<Level, GameDef[]> = {
  beginner: [...BEGINNER_1, ...BEGINNER_2],
  intermediate: [...INTERMEDIATE_1, ...INTERMEDIATE_2],
  expert: [...EXPERT_1, ...EXPERT_2],
};

export const ALL_GAMES: GameDef[] = LEVELS.flatMap(l => POOLS[l]);

export function gameById(id: string): GameDef | undefined {
  return ALL_GAMES.find(g => g.id === id);
}
